/**
 * Created by Akihiro-Kato on 2016/12/27.
 */

const data = {
  val: {
    per_page: 20,
    page: 1
  },
	paths: [
		{
		  BASE_URI: '//gids.jp/',
			PAGES_URL: '//gids.jp/wp-json/wp/v2/pages/',
			POSTS_URL: '//gids.jp/wp-json/wp/v2/posts/',
      LIMIT_POST_URI: '//gids.jp/wp-json/wp/v2/posts?per_page=20',
      TAGS_URI: '//gids.jp/wp-json/wp/v2/tags/',
      MEMBER_URI: '//gids.jp/wp-json/wp/v2/posts?tags=7&per_page=50',
      OPINION_URI: '//gids.jp/wp-json/wp/v2/posts?tags=12&per_page=50'
		}
	],
  menu: {
    home: {
      name: 'HOME',
      link: '/'
    },
    member: {
      name: 'MEMBER',
      link: '/tags/MEMBER'
    },
    project: {
      name: 'PROJECTS',
      link: '/tags/PROJECT'
    },
    opinion: {
      name: 'OPINION',
      link: '/tags/OPINION'
    },
    about: {
      name: 'ABOUT US',
      link: '/aboutus'
    },
    guide: {
      name: 'GUIDE',
      link: '/guide'
    },
    contact: {
      name: 'CONTACT',
      link: '/contact'
    }
  }
};
export default data;



// WEBPACK FOOTER //
// ./src/js/data.js